import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { InventoryControllerModule } from './controllers/InventoryController';
import { InventoryListView } from './list/list';

export const InventoryView = angular
  .module('acme.view.application.inventory', [uiRouter, 'ui.bootstrap', InventoryControllerModule, InventoryListView])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.inventory',
      url: '/addons',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'InventoryController',
          templateUrl: 'views/application/views/inventory/inventory.tpl.html',
        },
      },
      data: {
        permissions: ['ADDONS_VIEW'],
      },
    });
  }).name;
